// extracted by mini-css-extract-plugin
export default {"LoadingArrows":"y7bcK","rotatingfunction":"_6ghr7"};